/**
 * Котировки алгоритмов, которых snapshot.json не видит: collector.py на
 * liquorice-mm-2 хвостит только собственный WAL mm-v2 (всегда index=1).
 * Всё остальное (сейчас — эксперимент flat-price на liquorice-mm-1, index=2)
 * идёт из dashboard.known_rfqs через aggregator.py, публикуется отдельным
 * файлом. Беднее по полям, чем родной feed (нет edge/latency — тот путь их
 * не считает), но честно: outcome — реальный status/skip_reason из CSV, а
 * не выдумка.
 */
import { useEffect, useState } from 'react'
import type { QuoteRow } from '../types'

const CHART_BASE_URL = import.meta.env.VITE_LIVE_CHART_BASE_URL as string | undefined

export function useOtherQuotes(): QuoteRow[] {
  const [quotes, setQuotes] = useState<QuoteRow[]>([])

  useEffect(() => {
    if (!CHART_BASE_URL) return
    let stopped = false
    let timer: number | undefined
    const url = `${CHART_BASE_URL}/chart-other-quotes.json`

    const tick = async () => {
      if (stopped) return
      try {
        const res = await fetch(`${url}?_=${Date.now()}`, { cache: 'no-store' })
        if (res.ok) {
          const body = await res.json()
          setQuotes(body.quotes ?? [])
        }
      } catch (err) {
        console.error('[live] other-quotes fetch failed', err)
      } finally {
        if (!stopped) timer = window.setTimeout(tick, 3000)
      }
    }
    tick()
    return () => {
      stopped = true
      if (timer !== undefined) window.clearTimeout(timer)
    }
  }, [])

  return quotes
}
